import {
  Box,
  Container,
  Typography,
  styled,
} from '@mui/material';

const FooterWrapper = styled(Container)(
  ({ theme }) => `
        padding-top: ${theme.spacing(4)};
  `,
);

const Footer = () => (
  <FooterWrapper className="footer-wrapper">
    <Box
      sx={{
        textAlign: { xs: 'center', sm: 'right' },
        pt: { xs: 2, sm: 0 },
        pb: 2,
      }}
    >
      <Box>
        <Typography variant="subtitle1">
          &copy;
          {' '}
          {new Date().getFullYear()}
          {' '}
          HoloRay Inc.
        </Typography>
      </Box>
    </Box>
  </FooterWrapper>
);

export default Footer;
